import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface UseStylesProps {
  downloadProgress?: number | string | null;
  alignIconCenter?: boolean;
}

export const useStyles = ({
  downloadProgress,
  alignIconCenter
}: UseStylesProps) =>
  ({
    iconLeftCSS: {
      display: "flex",
      alignItems: "center",
      alignSelf: alignIconCenter ? "center" : "flex-start",
      marginRight: "8px",
      color: downloadProgress ? colors.textDisabled : "unset"
    },
    checkboxDiv: {
      display: "flex",
      alignItems: "center",
      alignSelf: "flex-start",

      "& > svg, & > label": {
        marginLeft: "8px"
      }
    },
    listChoiceContent: {
      flex: "1",
      color: downloadProgress ? colors.textDisabled : "unset",

      "& > span": {
        display: "block"
      }
    }
  }) as CSSObject;
